
const generateBasisUrl = function (url) {
  return Object.freeze({
    basUrl: url,
    parmUrl: (id) => url + `/${id}`,
  })
}

export const menu = generateBasisUrl('/ucenter/system/menus')

export const data = Object.freeze({
  get: (name) => `/internalcontrol/data/${name}`,
  add: (name) => `/internalcontrol/data/${name}`,
  update: (name, id) => `/internalcontrol/data/${name}/${id}`,
  del: (name, id) => `/internalcontrol/data/${name}/${id}`,
})

export const common = Object.freeze({
  get: (name) => `/internalcontrol/${name}`,
  add: (name) => `/internalcontrol/${name}`,
  update: (name, id) => `/internalcontrol/${name}/${id}`,
  del: (name, id) => `/internalcontrol/${name}/${id}`,
})


export const budgetYear = Object.freeze({
  get: '/internalcontrol/budget/year',
  add: '/internalcontrol/budget/year',
  update: (id) => `/internalcontrol/budget/year/${id}`,
  // check: (id) => `/internalcontrol/budget/year/check/${id}`
  start: (id) => `/internalcontrol/budget/year/start/${id}`,
  end: (id) => `/internalcontrol/budget/year/end/${id}`
})

export const budgetDetail = Object.freeze({
  update: (id) => `/internalcontrol/budget/detail/${id}`,
  add: '/internalcontrol/budget/detail',
  getApply: '/internalcontrol/budget/detail/apply',
  submit: (id) => `/internalcontrol/budget/detail/submit/${id}`,
  submitBack: (id) => `/internalcontrol/budget/detail/submit/back/${id}`,
  firstCheck: (id) => `/internalcontrol/budget/detail/first_check/${id}`,
  firstCheckBack: (id) => `/internalcontrol/budget/detail/first_check/back/${id}`,
  lastCheck: (id) => `/internalcontrol/budget/detail/last_check/${id}`,
  lastCheckBack: (id) => `/internalcontrol/budget/detail/last_check/back/${id}`
})

export const purchaseApply = Object.freeze({
  get: '/internalcontrol/purchase/apply',
  update: (id) => `/internalcontrol/purchase/apply/${id}`,
  submit: (id) => `/internalcontrol/purchase/apply/submit/${id}`,
  start: (id) => `/internalcontrol/purchase/apply/start/${id}`,
  recall: (id) => `/internalcontrol/purchase/apply/recall/${id}`,
  check: (id) => `/internalcontrol/purchase/apply/check/${id}`,
  back: (id) => `/internalcontrol/purchase/apply/back/${id}`
})

export const purchase = Object.freeze({
  get: '/internalcontrol/purchase',
  update: (id) => `/internalcontrol/purchase/${id}`,
  submit: (id) => `/internalcontrol/purchase/submit/${id}`,
  start: (id) => `/internalcontrol/purchase/start/${id}`,
  recall: (id) => `/internalcontrol/purchase/recall/${id}`,
  check: (id) => `/internalcontrol/purchase/check/${id}`,
  back: (id) => `/internalcontrol/purchase/back/${id}`,
  type: (id) => `/internalcontrol/purchase/type/${id}`
})

export const purchaseDetail = Object.freeze({
  get: '/internalcontrol/purchase/detail',
  update: (id) => `/internalcontrol/purchase/detail/${id}`,
  delType: (id) => `/internalcontrol/purchase/detail/del/type/${id}`,
})
